import type { QueryClient } from "@tanstack/react-query";
import { BaseApiHooksRepository } from "../../base-api-hooks.repository";
import type {
  ImportParticipantsResult,
  ClassifyParticipantsResult,
} from "@shared/schemas/event-participant.schemas";
import type {
  ImportJsonVariables,
  ClassifyJsonVariables,
} from "./import.types";
import { createImportsApi } from "./imports.api";
import { onParticipantsImported } from "../../cache-actions";
import type { AxiosInstance } from "axios";

export class ImportHooksHttpRepositoryImpl extends BaseApiHooksRepository {
  private readonly api;

  constructor(queryClient: QueryClient, apiClient: AxiosInstance) {
    super(queryClient);
    this.api = createImportsApi(apiClient);
  }

  createHooks() {
    return {
      useImportJson: () =>
        this.mutation({
          fn: ({ eventIdPublic, participants }: ImportJsonVariables) =>
            this.api.importJson(eventIdPublic, participants),
          parse: (result: ImportParticipantsResult) => result,
          onSuccess: (_data, vars) => {
            onParticipantsImported(this.queryClient, vars.eventIdPublic);
          },
        }),

      useClassifyJson: () =>
        this.mutation({
          fn: ({ eventIdPublic, participants }: ClassifyJsonVariables) =>
            this.api.classifyJson(eventIdPublic, participants),
          parse: (result: ClassifyParticipantsResult) => result,
        }),
    };
  }
}
